export function LocalServer() {
    // return 'http://127.0.0.1:8001/';
    return 'https://api.sevanasahayi.com/';
}